// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__pYK98","header":"styles_header__mFIDI","badge":"styles_badge__pYzxl","fadeInOut":"styles_fadeInOut__KGwcK","loader":"styles_loader__oI1j7"};